module.exports = __webpack_public_path__ + "img/marchi.35e5e131.png";